export function getListRevealMotionProps(index, { startX = 0, endX = 0, startY = 0, endY = 0, delayMultiplier = 0.1 } = {}) {
    return {
        initial: { x: startX, y: startY, opacity: 0 },
        animate: { x: endX, y: endY, opacity: 1 },
        transition: { type: 'spring', bounce: 0.5, delay: index * delayMultiplier }
    };
}
